<template>
  <div class="policy-page container">
    <header class="policy-header">
      <h1>Política de Privacidade — {{ appName }}</h1>
      <p class="muted">
        Última atualização: {{ lastUpdated }}
      </p>
      <div class="policy-actions">
        <button
          class="btn btn-outline-primary"
          @click="printPage"
        >
          Imprimir
        </button>
      </div>
    </header>

    <section class="policy-section">
      <h2>1. Introdução</h2>
      <p>
        Esta Política de Privacidade descreve como a {{ appName }} coleta, usa,
        armazena e protege os seus dados pessoais quando você utiliza nossos
        serviços. Ao utilizar a aplicação, você concorda com as práticas aqui
        descritas.
      </p>
    </section>

    <section class="policy-section">
      <h2>2. Dados que coletamos</h2>
      <ul>
        <li>Dados de identificação (nome, e-mail, telefone).</li>
        <li>Dados de conta (nome de usuário, preferências).</li>
        <li>Dados de uso e diagnóstico (logs, interações, erros).</li>
        <li>Dados técnicos e de dispositivo (IP, tipo de navegador).</li>
      </ul>
    </section>

    <section class="policy-section">
      <h2>3. Finalidades do tratamento</h2>
      <p>Utilizamos seus dados para:</p>
      <ul>
        <li>fornecer e melhorar nossos serviços;</li>
        <li>autenticar e administrar sua conta;</li>
        <li>enviar comunicações relacionadas ao serviço e notificações;</li>
        <li>cumprir obrigações legais e proteger direitos.</li>
      </ul>
    </section>

    <section class="policy-section">
      <h2>4. Compartilhamento de dados</h2>
      <p>
        A {{ appName }} não vende seus dados pessoais. Podemos compartilhar
        informações com provedores de serviço que atuam em nosso nome (por
        exemplo, serviços de hospedagem, analytics) e quando exigido por lei.
      </p>
    </section>

    <section class="policy-section">
      <h2>5. Cookies e tecnologias semelhantes</h2>
      <p>
        Utilizamos cookies e tecnologias similares para melhorar a experiência
        do usuário, analisar o uso e administrar funcionalidades essenciais.
        Você pode controlar preferências de cookies através do seu navegador.
      </p>
    </section>

    <section class="policy-section">
      <h2>6. Segurança</h2>
      <p>
        Adotamos medidas técnicas e administrativas razoáveis para proteger os
        dados pessoais contra acesso não autorizado, alteração e divulgação.
        Nenhum método de transmissão pela internet ou armazenamento eletrônico
        é 100% seguro; por isso não garantimos absoluta segurança.
      </p>
    </section>

    <section class="policy-section">
      <h2>7. Retenção</h2>
      <p>
        Reteremos os dados pelo tempo necessário para cumprir finalidades
        descritas nesta política, atender a obrigações legais e resolver
        disputas.
      </p>
    </section>

    <section class="policy-section">
      <h2>8. Seus direitos</h2>
      <p>
        Dependendo de sua jurisdição, você pode ter direitos sobre seus dados,
        como acessar, corrigir, excluir, restringir o processamento ou portar
        dados. Para solicitar o exercício desses direitos, entre em contato via
        <a :href="`mailto:${contactEmail}`">{{ contactEmail }}</a>.
      </p>
    </section>

    <section class="policy-section">
      <h2>9. Alterações nesta política</h2>
      <p>
        Podemos atualizar esta política periodicamente. Publicaremos a data da
        última atualização no topo desta página.
      </p>
    </section>

    <section class="policy-section">
      <h2>10. Contato</h2>
      <p>
        Para dúvidas ou solicitações sobre privacidade, contacte-nos em
        <a :href="`mailto:${contactEmail}`">{{ contactEmail }}</a>.
      </p>
    </section>
  </div>
</template>

<script>
export default {
  name: 'PoliticaPrivacidade',
  data() {
    return {
      appName: 'Honorarium',
      // Mantenha essa data atualizada quando publicar alterações
      lastUpdated: '25 de novembro de 2025',
      contactEmail: 'suporte@honorarium.com.br',
    }
  },
  methods: {
    printPage() {
      window.print()
    },
  },
}
</script>

<style scoped>
.policy-page { padding: 1.25rem 1rem; }
.policy-header { display:flex; align-items:center; justify-content:space-between; gap:1rem; flex-wrap:wrap; margin-bottom:1rem }
.policy-header h1 { margin:0; font-size:1.5rem }
.muted { color: #6c757d; margin:0 }
.policy-section { margin:1rem 0 }
.policy-section h2 { font-size:1.125rem; margin-bottom:0.5rem }
.policy-actions .btn { white-space:nowrap }
@media (min-width:768px){ .policy-page { padding:2rem } }
</style>
